
export const SEARCH_FLIGHTS = "SEARCH_FLIGHTS";
export const FILTER_FLIGHTS = "FILTER_FLIGHTS";
export const CLEAR_FILTER_FLIGHTS = "CLEAR_FILTER_FLIGHTS";